import * as React from 'react';
import { IRootState } from 'src/reducers';
import { connect } from 'react-redux';
import selectors from 'src/selectors';

interface ILoadingPanelStateProps {
    isPanelLoading: boolean;
}

interface ILoadingPanelOwnProps {
    loadingAction: string;
    children: Array<JSX.Element> | JSX.Element;
}

type ILoadingPanelProps = ILoadingPanelStateProps & ILoadingPanelOwnProps;

class LoadingPanel extends React.Component<ILoadingPanelProps> {
    public render() {
        if (this.props.isPanelLoading) {
            return <div>Loading</div>;
        } else if (this.props.children) {
            return <div>{this.props.children}</div>;
        }

        return <span />;
    }
}

const mapStateToProps = (state: IRootState, ownProps: ILoadingPanelOwnProps) => ({
    isPanelLoading: selectors.layout.isPanelLoading(state, ownProps.loadingAction),
});

export default connect(mapStateToProps)(LoadingPanel);



// WEBPACK FOOTER //
// ./src/components/common/LoadingPanel.tsx